export interface RadiiVariants {
  /** @return 5px */
  base: string;
  /** @return 8px */
  button: string;
  /** @return 8px */
  card: string;
  /** @return 8px */
  paper: string;
  /** @return 4px */
  textOnly: string;
}

export interface PressRadiiVariants {
  /** @return 4px */
  base: string;
  /** @return 4px */
  button: string;
  /** @return 8px */
  card: string;
  /** @return 8px */
  paper: string;
  /** @return 4px */
  textOnly: string;
}

const base: RadiiVariants = {
  base: '5px',
  button: '8px',
  card: '8px',
  paper: '8px',
  textOnly: '4px'
};

const press: PressRadiiVariants = {
  base: '4px',
  button: '4px',
  card: '4px',
  paper: '4px',
  textOnly: '4px',
};

const radii = {
  ...base,
  products: {
    chart: base,
    co: base,
    edu: base,
    press,
    spark: base
  }
};

export default radii;
